<template>
	<div class="thread-users-wrapper">
		<div class="thread-users">
			<div class="thread-users-heading">
				<div class="go-back" @click="close">
					<CloseIcon type="regular" />
				</div>
				<h2 class="thread-users-header">
					{{ $t('admin_groups_members_label') }}
				</h2>
			</div>

			<div class="thread-users-content group-settings-content">
				<GroupPeople :bubbleId="threadId" />
			</div>
		</div>
	</div>
</template>

<script>
import GroupPeople from '@/components/GroupSettings/GroupPeople'
import { CloseIcon } from '@/icons'

export default {
	name: 'ThreadUsers',
	components: { CloseIcon, GroupPeople },
	props: {
		threadId: [String, Number],
	},
	methods: {
		close() {
			this.$router.go(-1)
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

@media screen and (max-width: 1000px) {
	.thread-users-wrapper {
		left: 0px !important;
	}
}

.thread-users-wrapper {
	position: absolute;
	top: 0;
	bottom: 0;
	right: 0;
	left: 280px;
	background-color: var(--neutral-0);
	z-index: 7;
	padding-bottom: 40px;
}

.thread-users {
	display: flex;
	flex-direction: column;
	width: 830px;
	height: 100%;
	margin: 0 auto;
	padding: 0 20px;
}

.thread-users-heading {
	position: relative;
}

.go-back {
	position: absolute;
	left: 0;
	top: 10px;
	cursor: pointer;
	font-size: 28px;
	color: var(--neutral-400);

	&:hover {
		color: var(--neutral-500);
	}
}

.thread-users-header {
	padding-left: 20px;
	margin-bottom: 30px;
	font-family: Avenir-Heavy;
	font-size: 30px;
	font-weight: normal;
	line-height: 1.2;
	text-align: center;
	color: var(--neutral-800);
}

.thread-users-content {
	flex: 1;
	overflow-y: auto;
}
</style>
<style lang="scss">
@import 'src/sass/variables';

@include overrideScheme('dark') {
	.thread-users-wrapper {
		background-color: var(--neutral-100);
	}
}
</style>
